class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    if (this.hasSubscription || this.cookie) return;

    this.popup.setAttribute("role", "dialog");
    this.popup.setAttribute("aria-modal", "true");
    this.popup.setAttribute("tabindex", "-1");

    const heading = this.popup.querySelector("h1, h2, h3");
    if (heading) {
      if (!heading.id) heading.id = "notification-popup-title";
      this.popup.setAttribute("aria-labelledby", heading.id);
    }

    if (this.closeBtn) {
      if (!this.closeBtn.getAttribute("aria-label")) {
        this.closeBtn.setAttribute("aria-label", "Close newsletter popup");
      }
      this.closeBtn.setAttribute("role", "button");
    }

    setTimeout(() => this.openPopup(), this.delay * 1000);

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.closePopup();
      });
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !this.popup.classList.contains("hidden")) {
        this.closePopup();
      }
    });

    this.popup.addEventListener("keydown", (e) => {
      if (e.key !== "Tab" || this.popup.classList.contains("hidden")) return;
      const focusables = this.popup.querySelectorAll(
        'a[href], button, input:not([type=hidden]), textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  openPopup() {
    this.previouslyFocused = document.activeElement;
    this.popup.classList.remove("hidden");
    this.popup.classList.add("wt-popup-fade-in");
    setTimeout(() => {
      if (this.closeBtn) this.closeBtn.focus();
    }, 100);
  }

  closePopup() {
    this.popup.classList.add("hidden");
    this.setCookie("hideNotificationPopup", "true", 7);
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === "function") {
      this.previouslyFocused.focus();
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);